export var CATEGORY_CLICK_EVENT_HIERARCHY = ['select_category', 'Quick links'];
export var CATEGORY_BAR_TEST_ID = 'category-bar';
export var CATEGORY_BAR_TEST_ID_MOBILE = 'category-bar-mobile';
export var CATEGORY_BAR_TEST_ID_ITEM = 'category-bar-item';
//# sourceMappingURL=constants.js.map